<template>
    <q-dialog
        v-model="modal"
            transition-show="scale"
            transition-hide="scale"
        :maximized="$q.platform.is.mobile">
        <q-card class="modal-sign modal-40 modal-with-tabs p-0">
            <div class="modal-header">
                <div class="modal-close" @click="modal=false">
                    <span aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" xml:space="preserve">
                            <path fill="" d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                        </svg>
                    </span>
                </div>
                <div class="modal-tab">
                    <div :class="{ active: isForm('login') }" @click.prevent="setForm('login')" ><span>Вход</span></div>
                    <div :class="{ active: isForm('registration') }" @click.prevent="setForm('registration')"><span>Регистрация</span></div>
                </div>
            </div>
            <login v-if="isForm('login')"></login>
            <registration v-if="isForm('registration')"></registration>
            <remember v-if="isForm('remember')"></remember>
        </q-card>
    </q-dialog>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex';
    import Login from './Auth/Login.vue';
    import Registration from './Auth/Registration.vue';
    import Remember from './Auth/Remember.vue';

    export default {
        name: 'CustomerAuth',
        data() {
            return {
                defaultTab: 'login'
            }
        },
        components: {
            login: Login,
            registration: Registration,
            remember: Remember
        },
        watch: {
            modal (newValue) {
                if (newValue) {
                    this.setForm(this.defaultTab);

                    this.defaultTab = 'login';
                }
            }
        },
        mounted() {
            const hash = window.location.hash.substring(1);

            if (this.isCorrectFormName(hash)) {
                this.defaultTab = hash;

                this.showModal();
            }
        },
        methods: {
            ...mapMutations('auth', [
                'showModal',
                'hideModal',
                'setForm',
            ]),

            isForm (form) {
                return this.$store.state.auth.form === form;
            },
        },
        computed: {
            ...mapGetters('auth', [
                'isCorrectFormName',
            ]),

            modal: {
                get () {
                    return this.$store.state.auth.modal;
                },

                set () {
                    this.hideModal();
                }
            },
        }
    }
</script>
